import React from 'react';
import { WidePageContextProvider } from 'src/client/containers/App/WidePageContextProvider';
import { CamsContextProvider } from 'src/client/containers/Cams/CamsContextProvider';
import { SFWSiteProvider } from './SFWSiteProvider';

export const ManSiteProviders: React.FC = ({ children }) => {
  return (
    <SFWSiteProvider>
      <CamsContextProvider>
        <WidePageContextProvider>{children}</WidePageContextProvider>
      </CamsContextProvider>
    </SFWSiteProvider>
  );
};
